import React, {useEffect} from "react";
import "./style.css";
import {useTranslation} from "react-i18next";
import Popup from "../../lib/Popup";
import CookiePreferencesPopup from "./CookiePreferencesPopup";
import styled from "styled-components";
import {cookieStorage} from "./lib/cookieStorage"
import { selectWhitelabelInfo } from "../../redux/selectors/whitelabel";
import { useSelector } from "react-redux";

const ButtonContainer = styled.div`
  .btn-secondary {
      background-color: ${props => props.whiteLabelInfo?.color2 || '#f5755d'};
      border-color: ${props => props.whiteLabelInfo?.color2 || '#f5755d'};
  }
       .btn-link {
            color: ${props => props.whiteLabelInfo?.color2 || '#f5755d'};
        }
`;
const Container = styled.div`
      background-color: ${props => props.whiteLabelInfo?.color3 || '#696969f9'};
`;

function CookieBanner() {
  const [t] = useTranslation("cookies");
  const [showBanner, setShowBanner] = React.useState(false);

  const storageType = cookieStorage;
  const consentPropertyName = "cookie-consent";
  const statisticsPropertyName = "stats";
  const marketingPropertyName = "marketing";
  const requiredPropertyName = "required";

  const whiteLabelInfo = useSelector(selectWhitelabelInfo);
  const shouldShowPopup = () => !storageType.isAnswered();

  const saveToStorage = (PropertyName) =>
    storageType.setItem(PropertyName, true);

  const acceptfn = () => {
    saveToStorage(consentPropertyName);
    saveToStorage(statisticsPropertyName);
    saveToStorage(marketingPropertyName);
    saveToStorage(requiredPropertyName);
    setShowBanner(false);
  };

  useEffect(() => {
    if (shouldShowPopup()) {
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const preferencesCookies = (statistics, marketing) => {
    if (statistics) {
      saveToStorage(statisticsPropertyName);
    }
    if (marketing) {
      saveToStorage(marketingPropertyName);
    }
    saveToStorage(consentPropertyName);
    saveToStorage(requiredPropertyName);
    Popup.close();
    setShowBanner(false);
  };

  const acceptAllCookies = () => {
    Popup.close();
    acceptfn();
  };

  const showPreferences = () => {
    Popup.show(
      <CookiePreferencesPopup
        preferencesCookies={preferencesCookies}
        acceptAllCookies={acceptAllCookies}
      />,
      true
    );
  };
  if (!showBanner) {
    return null;
  }

  return (
    <Container id="consent-banner" whiteLabelInfo={whiteLabelInfo}>
      <div className="container">
        <div className="row">
          <div className="col-4 col-lg-2">
            <h4>{t("Cookies on this website")}</h4>
          </div>
          <div className="col-8 col-lg-7">
            <p>{t("Cookies_Banner_Text")}</p>
          </div>
          <div className="col-12 mt-4 mt-lg-0 col-lg-3 text-center">
            <ButtonContainer whiteLabelInfo={whiteLabelInfo}>
              <button onClick={acceptfn} className="btn btn-secondary">
                {t("Accept_Cookies_btn")}
              </button>
            <div>
              <button className="btn btn-link" onClick={showPreferences}>
                {t("Preferences_btn")}
              </button>
            </div>
            </ButtonContainer>
          </div>
        </div>
      </div>
    </Container>
  );
}

export default CookieBanner;
